// Keep this module leaf-only. These hotkeys are consumed by MDS components that are also used
// by the Chrome extension, so importing app-level keyboard shortcut modules here causes the
// extension typecheck to pull in the mem-client shortcut graph and unrelated app-only code.
export const COMBOBOX_REMOVE_LAST_MENTION_HOTKEY = "Backspace";
export const SESSION_CLOSE_ARTIFACT_HOTKEY = "Escape";
